import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Container, Row, Item } from '@johnlewispartnership/wtr-ingredients/foundations/grid';

const CentralLayout = memo(({ children }) => {
  return (
    <Container>
      <Row>
        <Item sm={8} md={6} lg={4} xl={4} smOffset={2} mdOffset={3} lgOffset={4} xlOffset={4}>
          {children}
        </Item>
      </Row>
    </Container>
  );
});

CentralLayout.displayName = 'CentralLayout';

CentralLayout.propTypes = {
  children: PropTypes.node,
};

CentralLayout.defaultProps = {
  children: null,
};

export default CentralLayout;
